import * as React from "react";
import { FundNameDataCell } from "../FundNameDataCell/FundNameDataCell";
import { AsOfDataCell } from "../AsOfDataCell/AsOfDataCell";

const styles = require('./FundNameRow.pcss');
const dataCellStyles = require('../AsOfDataCell/AsOfDataCell.pcss');

interface IProps{
    row?: any;
    className?: string;
    name?: string;
    key?: string;
    isin?: string;
    perfData?: any[];
    url?: string;
    translation?: string[];
}

export class FundNameRow extends React.Component<IProps, {}>{
    constructor(props){
        super(props);
    }

    render(){
        let fundName = this.translateShareType(this.props.translation, this.props.name),
            dataCells = this.getDataCells(this.props.perfData),
            url = this.props.url;
        return(
            <tr onClick={ this.handleClick.bind(url, this) } className={this.props.className || styles.innerHeading}>
                <FundNameDataCell className={ styles.fundName } name={ fundName || this.props.name }/>
                <td> </td>
                {dataCells}
                <td className={dataCellStyles.dataCell} colSpan={1}>{this.props.isin}</td>
            </tr>
        );
    }

    getPerfData(dataObj){
        let list = dataObj["values"], vals = [];
        list.forEach(function (item,index) {
           vals[index] = item.value;
        });
        return vals;
    }

    getDataCells(data){
        let list = this.getPerfData(data), res = [];
        for (let i = 0; i < 5; i++) {
            res.push(<AsOfDataCell key={i} dataPoint={(list[i]) ? (list[i].toFixed(1)+'%').replace('.',',') : '--'} />);
        }
        return res;
    }

    handleClick(url, e){
        e.preventDefault();
        if (url.props.url) {
            window.open(url.props.url, '');
        }
    }

    translateShareType(translation, name){
        let nameList = name.split(' - '), translated = '';
        for (let prop in translation) {
            if (translation[prop][2] === nameList[1].trim()) {
                translated = translation[prop][3];
            }
        }
        if(translated) {
            nameList[1] = translated.trim();
            name = nameList.join(' - ');
        }
        return name;
    }
}


// WEBPACK FOOTER //
// ./src/client/Rankia/Components/FundNameRow/FundNameRow.tsx